/**
 * Application Constants
 */

export const STUDENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const ASSESSMENT_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PAGE: 1,
};

// ── Student Filter Defaults ──
export const DEFAULT_PROFILE_FILTERS = {
  branch: "All Branches",
  semester: "All Semesters",
  year: "All Years",
};

export const DEFAULT_RESULT_FILTERS = {
  branch: "All Branches", semester: "All Semesters", year: "All Years",
  language: "All Languages", database: "All Databases", status: "All Status",
  overallStatus: "All", aptitude: "All", communication: "All",
  programming: "All", dbLevel: "All", scoreMin: "", scoreMax: "",
};

export const PROFILE_FILTER_MAP = {
  BRANCH:            { key: "branch",   optionsKey: "departments", defaultVal: "All Branches" },
  "GRADUATION YEAR": { key: "year",     optionsKey: "years",       defaultVal: "All Years" },
  SEMESTER:          { key: "semester",  optionsKey: "semesters",   defaultVal: "All Semesters" },
};

export const RESULT_FILTER_MAP = {
  Branch:            { key: "branch",        optionsKey: "departments",          defaultVal: "All Branches" },
  "GRADUATION YEAR": { key: "year",          optionsKey: "years",               defaultVal: "All Years" },
  Semester:          { key: "semester",       optionsKey: "semesters",           defaultVal: "All Semesters" },
  Language:          { key: "language",       optionsKey: "programmingLanguages", defaultVal: "All Languages", multiSelect: true },
  Database:          { key: "database",       optionsKey: "databases",           defaultVal: "All Databases" },
  Status:            { key: "status",         optionsKey: "assessmentStatuses",  defaultVal: "All Status", multiSelect: true },
  Programming:       { key: "programming",    optionsKey: "programmingLevels",   defaultVal: "All" },
  "Database Level":  { key: "dbLevel",        optionsKey: "databaseLevels",      defaultVal: "All" },
  Communication:     { key: "communication",  optionsKey: "communicationLevels", defaultVal: "All" },
  Aptitude:          { key: "aptitude",       optionsKey: "aptitudeLevels",      defaultVal: "All" },
  "Overall Status":  { key: "overallStatus",  optionsKey: "overallStatuses",     defaultVal: "All" },
};

export const STATUS_LABELS = {
  not_started: "Not Started", "not started": "Not Started",
  incomplete_left: "Incomplete", "incomplete left": "Incomplete",
};

export const COLUMN_INFO = {
  Programming: "Beginner: 0–54.9% • Intermediate: 55–74.9% • Advanced: 75–100%",
  "Database Level": "Beginner: 0–54.9% • Intermediate: 55–74.9% • Advanced: 75–100%",
  Communication: "A1/A2: 0–49% • B1: 50–69% • B2: 70–79% • C1/C2: 80–100%",
  Aptitude: "Weak: 0–45.8% • Developing: 45.9–62.4% • Adequate: 62.5–79.1% • Strong: 79.2–95.8% • Outstanding: 95.9–100%",
  "Overall Status": "Needs Training: <50% • Developmental: 50–79.9% • Interview Ready: ≥80%",
  Status: "Not Started: Assessment not yet created • Pending: Created, awaiting attempt • Completed: Successfully completed • Incomplete: Exited before finishing",
};

export const CHIP_PREFIX = {
  status: "Status", language: "Language", database: "Database",
  aptitude: "Aptitude", communication: "Comm", programming: "Prog",
  dbLevel: "DB", overallStatus: "Overall",
};

export const EXPORT_HEADERS = [
  "Student ID","Name","Branch","Graduation Year","Semester","Language","Database",
  "Status","Programming Level","Database Level","Communication Level","Aptitude Level",
  "Overall Status","Overall Score","Created At","Completed At","Email",
];

export const ADMIN_EMAILS = new Set([
  "aishwarya@flexontechnologies.com",
  "abhishek@flexontechnologies.com",
  "archi@flexontechnologies.com",
]);

